import React from "react";
import { Button } from "antd";
import { CheckSquareOutlined } from "@ant-design/icons";

export default function LinksButtonActive({ links, linksActive, onNext }) {
  return links.link.map((item) => {
    const buttonActive = {
      backgroundColor: "#ebfbee",
      borderColor: "#52c41a",
      color: "#52c41a",
      marginRight: "6px",
      marginTop: "6px",
    };
    const buttonInactive = {
      marginRight: "6px",
      marginTop: "6px",
    };
    const buttonStyle =
      item.nodeId === linksActive ? buttonActive : buttonInactive;
    const buttonIcon =
      item.nodeId === linksActive ? <CheckSquareOutlined /> : null;
    if (onNext) {
      return (
        <>
          <Button
            disabled
            icon={buttonIcon}
            key={item.nodeId}
            style={buttonStyle}
            type="primary"
          >
            {item.text}
          </Button>
        </>
      );
    }
  });
}
